<template>
    <DsTextInput
        v-model="model"
        ref="textInputRef"
        v-bind="$props"
        type="text"
    >
        <template
            v-if="$slots.label"
            #label
        >
            <slot name="label" />
        </template>

        <template
            v-if="$slots.labelTooltip"
            #labelTooltip
        >
            <slot name="labelTooltip" />
        </template>

        <template
            v-if="$slots.helperText"
            #helperText
        >
            <slot name="helperText" />
        </template>

        <template #leading>
            <DsIcon
                data-testid="ds-icon"
                icon="fa-magnifying-glass"
                size="sm"
            />
        </template>
        <template
            v-if="model"
            #trailing
        >
            <DsIconButton
                :disabled="disabled || readonly"
                icon="fa-solid fa-circle-xmark"
                size="xs"
                tooltipText="Clear search"
                @click="clearSearch"
            />
        </template>
    </DsTextInput>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';
import DsIconButton from '@ds/button/DsIconButton.vue';
import type { DsSearchInputProps, DsSearchInputSlots } from '@ds/form/input/DsSearchInput/search-input.types';
import DsTextInput from '@ds/form/input/text/DsTextInput.vue';
import { computed, useTemplateRef } from 'vue';

defineSlots<DsSearchInputSlots>();

withDefaults(defineProps<DsSearchInputProps>(), {
    size: 'md',
});

const model = defineModel<string>({ default: '' });

const textInputRef = useTemplateRef('textInputRef');
const inputElement = computed(() => textInputRef.value?.inputElement);

const clearSearch = () => {
    model.value = '';
    inputElement.value?.focus();
};

defineExpose({
    inputElement,
});
</script>
